import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

const COOKIE_NAME = process.env.REACT_APP_COOKIE_NAME;
const SECRET_KEY = process.env.REACT_APP_COOKIE_SECRET_KEY;
 
export const setEncryptedAuthCookie = (data) => {
  const stringData = JSON.stringify(data);
  const encryptedData = CryptoJS.AES.encrypt(stringData, SECRET_KEY).toString();
  const cookieOptions = {
    expires: 30,
    secure: true,
    sameSite: 'Lax',
    path: '/'
  };
  if (window.location.hostname.endsWith('rsnap.ai')) {
    cookieOptions.domain = '.rsnap.ai';
  }
  Cookies.set(COOKIE_NAME, encryptedData, cookieOptions);
};

export const getDecryptedAuthCookie = () => {
    try {
      const encryptedData = Cookies.get(COOKIE_NAME);
      if (!encryptedData) return null;  
      const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);  
      if (!decrypted) throw new Error('Decryption failed: empty string');  
      return JSON.parse(decrypted);
    } catch (error) {
      console.error('Failed to decrypt cookie:', error.message);
      return null;
    }
  };  

export const clearAuthCookie = () => {
  // Remove cookie for current host
  Cookies.remove(COOKIE_NAME, { path: '/' });
  // Also attempt removing cookie scoped to apex prod domain
  try {
    Cookies.remove(COOKIE_NAME, { path: '/', domain: '.rsnap.ai' });
  } catch (e) {
    // no-op
  }
};
